// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"3392ca1c","453":"d35d08b7","455":"4f09935f","525":"d278911c","681":"6ab63ad0","977":"5df23ada"}[chunkId] + ".chunk.js";
};